/**
 * Error returned when the input for a method is invalid
 */
export default class InvalidInputError extends Error {
  public ERROR_CODE = 'INVALID_INPUT';
  constructor(message : string) {
    super(message);
    Object.setPrototypeOf(this, InvalidInputError.prototype);
  }
}
